<template>
  <div ref="snack-bar" class="mdl-js-snackbar mdl-snackbar">
    <div class="mdl-snackbar__text"></div>
    <button class="mdl-snackbar__action" type="button"></button>
  </div>
</template>

<style lang="scss" scoped>
  .mdl-js-snackbar {
    background: rgba(0, 0, 0, 0.7);
  }
</style>

<script>
  export default{
    data(){
      return {};
    },

    methods: {
      showSnackBar(message, timeout = 3000, actionHandler = null, actionText = null){
        let data = {
          message: message,
          timeout: timeout
        };

        if(actionHandler){
          data.actionHandler = actionHandler;
        }

        if(actionText){
          data.actionText = actionText;
        }

        let snackbarContainer = this.$refs['snack-bar'];
        snackbarContainer.MaterialSnackbar.showSnackbar(data);
      }
    },

    created(){
      this.$root.$on('show-snack-bar', this.showSnackBar);
    },

    beforeDestroy(){
      this.$root.$off('show-snack-bar', this.showSnackBar);
    }
  };
</script>



// WEBPACK FOOTER //
// SnackBar.vue?72ed991b